module.exports = __webpack_public_path__ + "b26a66981a381c78af0b2c1356c55e4d.jpg";